import { render, staticRenderFns } from "./excludeCustomer.vue?vue&type=template&id=2aa598ec"
import script from "./excludeCustomer.vue?vue&type=script&lang=js"
export * from "./excludeCustomer.vue?vue&type=script&lang=js"
import style0 from "./excludeCustomer.vue?vue&type=style&index=0&id=2aa598ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports